
export default function Reliability() {
  const credentials = [
    {
      icon: 'ri-award-line',
      title: 'AWS Certified',
      description: 'American Welding Society certified welders with proven expertise in structural and specialty welding techniques.',
      features: ['Structural Welding', 'MIG/TIG/Stick', 'Code Compliance', 'Quality Assured']
    },
    {
      icon: 'ri-time-line',
      title: 'On-Time Guarantee',
      description: 'We respect your schedule and deadlines. Our mobile service arrives when promised, and projects finish on time.',
      features: ['Emergency Available', 'Scheduled Service', 'Fast Turnaround', 'Reliable Response']
    }
  ];

  const stats = [
    { number: '500+', label: 'Projects Completed' },
    { number: 'Mon-Sat', label: 'Service Days' },
    { number: '100%', label: 'Satisfaction Rate' }
  ];

  return (
    <section className="py-24 bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why Choose <span className="text-orange-500">Our Team</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Professional credentials, reliable service, and unwavering commitment to quality
          </p>
        </div>

        {/* Credentials Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-20">
          {credentials.map((cred, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-lg p-8 hover:bg-gray-750 transition-all duration-300 border border-gray-700 hover:border-orange-500 cursor-pointer group"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${cred.icon} text-4xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                {cred.title}
              </h3>

              {/* Description */}
              <p className="text-gray-300 mb-6 leading-relaxed">
                {cred.description}
              </p>

              {/* Features */}
              <ul className="space-y-2">
                {cred.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-lg text-orange-500"></i>
                    </div>
                    <span className="text-sm text-gray-400">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="bg-orange-500 rounded-lg p-8">
          <div className="grid grid-cols-3 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                  {stat.number}
                </div>
                <div className="text-sm md:text-base text-orange-100 font-semibold">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-sm mb-6">Certified & Trusted</p>
          <div className="flex flex-wrap justify-center gap-8 items-center">
            <div className="flex items-center gap-2 text-gray-300">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-shield-star-line text-2xl text-orange-500"></i>
              </div>
              <span className="font-semibold">AWS Certified</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-orange-500"></i>
              </div>
              <span className="font-semibold">Fully Insured</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-government-line text-2xl text-orange-500"></i>
              </div>
              <span className="font-semibold">OSHA Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
